

export default {
    home: {
        title: 'Game Store'
    },
    list: {
        title: 'Store',
        select_option: 'Select Option',
        more: 'More',
        less: 'Less',
    },
    detail : {
        title: 'Fill Information',
        game_info: 'Game Information',
        price: 'Price',
        unit: 'Unit',
        total: 'Total',
        total_point: 'Total point',
        point: 'Points',
        next: 'Next',
        fill: 'Fill ',
        select: 'Select ',
        please_select: 'Please Select ',
        please_enter: 'Please Enter ',
    }
}
